import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { Prompt } from 'react-router-dom';
import store from '../../../index';
import moment from 'moment';
import DateTime from '_class/DateTime';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Form, FormSpy } from 'react-final-form';
import { Spinner } from 'UI';
import { Field } from 'UI/Inputs';
import { Icon, Button, Flex } from '@haldor/ui';
import PersistentFormListener from 'components/Inputs/PersistentFormListener';
import { FormPrompt } from 'components/Inputs/FormPrompt';
import { updateFormInstance } from 'actions/templates';
import ColorScale from '_class/ColorScale';

var FormInstance = /*#__PURE__*/function (_Component) {
  _inherits(FormInstance, _Component);

  var _super = _createSuper(FormInstance);

  function FormInstance(props) {
    var _this;

    _classCallCheck(this, FormInstance);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.instance == null) {
        _this.setState({
          submitting: true
        });

        var values = {};

        _this.props.fields.forEach(function (field) {
          if (field.type.indexOf('INPUT') > -1) {
            values[field.name] = '';
          }
        });

        _this.submit(values);
      }

      _this.interval = setInterval(function () {
        _this.setState({
          edited: _this.state.edited
        });
      }, 30 * 1000);
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillMount", function () {
      if (_this.interval != null) {
        clearInterval(_this.interval);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_addToast", function (message) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'warning';
      var error = {
        translateMsg: message,
        type: type,
        target: 'API',
        time: new DateTime()
      };
      store.dispatch({
        type: 'ADD_ERROR',
        payload: error
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_addTimeStampedToast", function (message, timeStamp) {
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'warning';
      message = _this.props.translate(message) + ' ' + timeStamp;
      var error = {
        translateMsg: message,
        type: type,
        target: 'API',
        time: new DateTime()
      };
      store.dispatch({
        type: 'ADD_ERROR',
        payload: error
      });
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      return new Promise(function (resolve) {
        _this.setState({
          updating: true
        });

        var fieldResults = [];
        var status = values.status;

        if (status == null) {
          status = 'SAVED';
        }

        Object.keys(values).map(function (key, index) {
          var _this$props$instance;

          if (key == 'status') {
            return;
          }

          var templateField = _this.props.fields.find(function (t) {
            return t.name == key;
          });

          var instanceField = (_this$props$instance = _this.props.instance) === null || _this$props$instance === void 0 ? void 0 : _this$props$instance.fieldResults.find(function (t) {
            return t.fieldName == key;
          });
          var result = {
            'fieldName': key,
            'value': values[key],
            'FieldTemplateId': templateField != null ? templateField.id : null,
            'id': instanceField != null ? instanceField.id : null
          };
          fieldResults.push(result);
        });

        if (_this.props.onSubmit != null && _this.props.instance == null) {
          _this.setState({
            submitting: true
          });

          var data = {
            fieldResults: fieldResults,
            status: status
          };
          data.formID = _this.props.form;

          _this.props.onSubmit(data).then(function () {
            _this.setState({
              edited: moment().format(),
              submitting: false,
              updating: false,
              error: false
            });

            resolve(1);

            if (_this.props.onAbort != null) {
              _this.props.onAbort(true);
            }
          })["catch"](function () {
            _this._addToast('Form could not be saved. Please try again.', 'error');
          });
        } else {
          var _data = _this.props.instance;
          _data.fieldResults = fieldResults;
          _data.status = status;

          _this.props.updateFormInstance(_data).then(function () {
            _this.setState({
              edited: moment().format(),
              updating: false
            });

            resolve(1);

            if (_this.props.onAbort != null) {
              _this.props.onAbort(true);
            }
          })["catch"](function (error) {
            _this._addToast('Form could not be saved. Please try again.', 'error');

            console.log('promise catch FormInstance', error);

            _this.setState({
              updating: false
            });

            resolve({
              error: 'Could not sync'
            });
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "copyAnswerToTextField", function (answer, value, setValue) {
      var field = answer.formInstance.formTemplate.fields.find(function (t) {
        return t.name == answer.formField.fieldName;
      });

      if (value != null && value != '') {
        if (field.type == "FIELDS_INPUT_TEXTAREA") {
          setValue(answer.formField.fieldName, value + " \n\n" + "<blockquote><p>" + answer.formField.value + "</p>" + "<strong>- " + answer.formInstance.user.firstName + " " + answer.formInstance.user.lastName + "</strong></blockquote> \n\n" + "<br /><p> </p>");
        } else {
          setValue(answer.formField.fieldName, value + " " + answer.formInstance.user.firstName + " " + answer.formInstance.user.lastName + ": " + answer.formField.value);
        }
      } else {
        if (field.type == "FIELDS_INPUT_TEXTAREA") {
          setValue(answer.formField.fieldName, "<blockquote><p>" + answer.formField.value + "</p>" + "<strong>- " + answer.formInstance.user.firstName + " " + answer.formInstance.user.lastName + "</strong></blockquote> \n\n" + "<br /><p> </p>");
        } else {
          setValue(answer.formField.fieldName, answer.formInstance.user.firstName + " " + answer.formInstance.user.lastName + ": " + answer.formField.value);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "shrinkAllFields", function () {
      if (!_this.props.shrinkFields) {
        return false;
      }

      var titleWasFound = false;

      _this.props.fields.forEach(function (field, index) {
        if (field.type == 'FIELDS_ELEMENT_TITLE') {
          _this.shrinkField(field, index, _this.state.isAllFieldsShrinked);

          titleWasFound = true;
        }
      });

      if (!titleWasFound && _this.props.fields.length > 0) {
        _this.shrinkField(_this.props.fields[0], -1, _this.state.isAllFieldsShrinked);
      }

      _this.setState({
        isAllFieldsShrinked: !_this.state.isAllFieldsShrinked
      });
    });

    _defineProperty(_assertThisInitialized(_this), "findNextTitleIndex", function (array, currentIndex, override) {
      var tempList = [];
      if (currentIndex < array.length) tempList = array.slice(currentIndex + 1);
      var object = tempList.find(function (item) {
        return item.type == 'FIELDS_ELEMENT_TITLE';
      });
      if (!object && !override) return -1;
      var nextIndex = array.findIndex(function (item) {
        return item.id == object.id;
      });
      return nextIndex;
    });

    _defineProperty(_assertThisInitialized(_this), "shrinkField", function (clickedElement, index, visible) {
      if (!_this.props.shrinkFields) {
        return false;
      }

      var hiddenFields = _this.state.hiddenFields;

      if (clickedElement.type === 'FIELDS_ELEMENT_TITLE') {
        clickedElement.visible = visible ? false : true;
        clickedElement.toggled = visible;
      }

      var nextTitleIndex = null;
      nextTitleIndex = _this.findNextTitleIndex(_this.props.fields, index);
      if (!nextTitleIndex || nextTitleIndex === -1) nextTitleIndex = _this.props.fields.length;

      var _loop = function _loop() {
        index = index + 1;
        var field = _this.props.fields[index];

        if (field != null) {
          if (field.type == 'FIELDS_ELEMENT_TITLE') {
            return {
              v: false
            };
          }

          var foundIndex = hiddenFields.findIndex(function (hidden) {
            return field.id == hidden.id;
          });

          if (visible) {
            if (foundIndex > -1) {
              hiddenFields.splice(foundIndex, 1);
            }
          } else {
            if (foundIndex == -1) {
              hiddenFields.push(field);
            }
          }

          _this.setState({
            hiddenFields: hiddenFields
          });
        }
      };

      while (index <= nextTitleIndex) {
        var _ret = _loop();

        if (_typeof(_ret) === "object") return _ret.v;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "containsAnswer", function (answer) {
      var doc = new DOMParser().parseFromString(answer, 'text/html');

      if (doc.body.textContent.trim() == "") {
        return false;
      } else {
        return true;
      }
    });

    var edited = null;

    if (_this.props.instance != null) {
      edited = moment.utc(_this.props.instance.edited).local().format();
    }

    _this.state = {
      edited: null,
      hiddenFields: [],
      submitting: false,
      updating: false,
      isAllFieldsShrinked: false
    };
    _this.form = /*#__PURE__*/React.createRef();
    _this.interval = null;
    return _this;
  }

  _createClass(FormInstance, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          submitting = _this$props.submitting,
          user = _this$props.user,
          followUp = _this$props.followUp,
          translate = _this$props.translate,
          instance = _this$props.instance;

      if (this.props.fields == null) {
        return null;
      }

      var isStudent = user.isStudent();
      var containerClass = 'form form-component form-instance';
      var isDisabled = false;

      if (this.props.shrinkFields) {
        containerClass += ' shrinkable';
      }

      if (followUp && isStudent && !this.props.studentLed) {
        isDisabled = true;
      }

      if (this.props.locked) {
        isDisabled = true;
      }

      var shrinkAllclassName = "shrink-all";
      if (!this.state.isAllFieldsShrinked) shrinkAllclassName += " flip";

      var fields = _toConsumableArray(this.props.fields);

      fields.sort(function (a, b) {
        return a.sortOrder > b.sortOrder ? 1 : -1;
      });
      return /*#__PURE__*/React.createElement(Form, {
        initialValues: this.props.initialValues,
        mutators: {
          setStatusSubmitted: function setStatusSubmitted(args, state, utils) {
            utils.changeValue(state, 'status', function () {
              return 'SUBMITTED';
            });
          },
          setValue: function setValue(_ref, state, utils) {
            var _ref2 = _slicedToArray(_ref, 2),
                field = _ref2[0],
                value = _ref2[1];

            utils.changeValue(state, field, function () {
              return value;
            });
          }
        },
        onSubmit: this.submit,
        keepDirtyOnReinitialize: true,
        render: function render(_ref3) {
          var _this2$props$instance, _this2$props$instance2;

          var handleSubmit = _ref3.handleSubmit,
              form = _ref3.form;
          return /*#__PURE__*/React.createElement("form", {
            onSubmit: handleSubmit,
            className: "form form-component",
            style: {
              position: 'relative'
            },
            ref: _this2.form
          }, /*#__PURE__*/React.createElement(FormPrompt, {
            hasUnsavedChanges: form.getState().dirty && !form.getState().submitSucceeded || form.getState().dirtySinceLastSubmit,
            formPromptMessage: _this2.props.translate('forminstance-error-leave-message')
          }), /*#__PURE__*/React.createElement(PersistentFormListener, {
            name: "form-instance-".concat(instance === null || instance === void 0 ? void 0 : instance.id),
            initialValues: _this2.props.initialValues,
            lastModifiedUTC: instance === null || instance === void 0 ? void 0 : instance.edited,
            addTimeStampedToast: _this2._addTimeStampedToast
          }), _this2.state.submitting ? /*#__PURE__*/React.createElement("div", {
            className: "is_sending"
          }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
            className: "loading-spinner"
          }))) : null, /*#__PURE__*/React.createElement("div", {
            className: containerClass
          }, _this2.props.shrinkFields ? /*#__PURE__*/React.createElement("div", {
            onClick: _this2.shrinkAllFields,
            className: shrinkAllclassName
          }, /*#__PURE__*/React.createElement(Icon, {
            name: "Chevron"
          }), " ", _this2.state.isAllFieldsShrinked ? _this2.props.translate('fold-out-all') : _this2.props.translate('fold-them-all-up')) : null, fields.map(function (field, index) {
            var _form$getFieldState;

            var value = (_form$getFieldState = form.getFieldState(field.name)) === null || _form$getFieldState === void 0 ? void 0 : _form$getFieldState.value;
            var answers = [];

            if (_this2.props.references != null) {
              _this2.props.references.forEach(function (form) {
                if (form.form.reference.formTemplate.id == _this2.props.formTemplate.id) {
                  var _form$formInstance, _form$formInstance$re, _form$formInstance$re2;

                  var formField = (_form$formInstance = form.formInstance) === null || _form$formInstance === void 0 ? void 0 : (_form$formInstance$re = _form$formInstance.reference) === null || _form$formInstance$re === void 0 ? void 0 : (_form$formInstance$re2 = _form$formInstance$re.fieldResults) === null || _form$formInstance$re2 === void 0 ? void 0 : _form$formInstance$re2.find(function (t) {
                    return t.fieldTemplateId == field.id;
                  });

                  if (formField != null) {
                    answers.push({
                      formField: formField,
                      formInstance: form.formInstance.reference
                    });
                  }
                }
              });
            }

            field.onBlur = function () {
              if (_this2.props.followUp == true && !_this2.props.user.isStudent()) {
                _this2.form.current.dispatchEvent(new Event('submit', {
                  cancelable: true,
                  bubbles: true
                }));
              }
            };

            var foundInHidden = null;

            if (_this2.props.shrinkFields) {
              field.onLabelClick = function () {
                return _this2.shrinkField(field, index, field.visible);
              };

              foundInHidden = _this2.state.hiddenFields.find(function (hidden) {
                return hidden.id == field.id;
              });
            }

            field.disabled = isDisabled;
            var className = null;
            if (foundInHidden != null) className = 'hidden-field';
            if (field.toggled) className = 'flip';
            return /*#__PURE__*/React.createElement("div", {
              key: 'field-' + field.id,
              className: className
            }, user != null && (!user.isStudent() || _this2.props.studentLed) && !isDisabled ? /*#__PURE__*/React.createElement("div", {
              className: "user-answers"
            }, answers.map(function (answer) {
              if (!_this2.containsAnswer(answer.formField.value)) {
                return null;
              }

              return /*#__PURE__*/React.createElement("div", {
                className: "user-answer",
                key: answer.formInstance.id
              }, /*#__PURE__*/React.createElement("div", {
                className: "answer-value",
                dangerouslySetInnerHTML: {
                  __html: answer.formField.value
                }
              }), /*#__PURE__*/React.createElement(Flex, {
                center: true
              }, /*#__PURE__*/React.createElement("div", {
                className: "creator"
              }, answer.formInstance.user.firstName + " " + answer.formInstance.user.lastName, ' • ' + new DateTime(answer.formInstance.created).getDateStamp()), /*#__PURE__*/React.createElement("div", {
                className: "quote-button",
                onClick: function onClick() {
                  _this2.copyAnswerToTextField(answer, value, form.mutators.setValue);
                }
              }, /*#__PURE__*/React.createElement(Icon, {
                name: "Quote"
              }), _this2.props.translate('quote'))));
            })) : null, /*#__PURE__*/React.createElement(Field, field));
          }), /*#__PURE__*/React.createElement(FormSpy, {
            subscription: {
              submitFailed: true
            }
          }, function (_ref4) {
            var submitFailed = _ref4.submitFailed;
            return submitFailed ? /*#__PURE__*/React.createElement("div", {
              className: "df aic form-save-error"
            }, /*#__PURE__*/React.createElement(Icon, {
              name: "Alert_Red"
            }), " ", _this2.props.translate('Form could not be saved. Please try again.')) : null;
          }), !isDisabled ? /*#__PURE__*/React.createElement("div", {
            className: "form-row submit spacing",
            style: _this2.props.followUp ? {
              marginBottom: 0
            } : {}
          }, /*#__PURE__*/React.createElement(Button, {
            onClick: function onClick(e) {
              e.preventDefault();
              form.mutators.setStatusSubmitted();
              form.submit();
            }
          }, ((_this2$props$instance = _this2.props.instance) === null || _this2$props$instance === void 0 ? void 0 : _this2$props$instance.status) == 'SUBMITTED' || _this2.props.followUp ? _this2.props.translate('save') : _this2.props.translate('submit'), submitting || _this2.state.updating ? /*#__PURE__*/React.createElement(Spinner, {
            small: true
          }) : null), ((_this2$props$instance2 = _this2.props.instance) === null || _this2$props$instance2 === void 0 ? void 0 : _this2$props$instance2.status) != 'SUBMITTED' && !_this2.props.followUp ? /*#__PURE__*/React.createElement(Button, {
            disabled: submitting || _this2.state.updating,
            type: "secondary"
          }, submitting || _this2.state.updating ? /*#__PURE__*/React.createElement(Spinner, {
            small: true,
            center: true
          }) : _this2.props.translate('save')) : null, /*#__PURE__*/React.createElement(FormSpy, {
            subscription: {
              submitSucceeded: true,
              modifiedSinceLastSubmit: true
            }
          }, function (_ref5) {
            var submitSucceeded = _ref5.submitSucceeded,
                modifiedSinceLastSubmit = _ref5.modifiedSinceLastSubmit;
            return submitSucceeded && !modifiedSinceLastSubmit ? /*#__PURE__*/React.createElement("span", {
              className: "dif aic size-12 save-indicator"
            }, /*#__PURE__*/React.createElement(Icon, {
              name: "Check"
            }), translate('saved')) : null;
          }), /*#__PURE__*/React.createElement("div", {
            className: "clearfix"
          })) : null));
        }
      });
    }
  }]);

  return FormInstance;
}(Component);

function mapStateToProps(state, ownProps) {
  var initialValues = null;

  if (ownProps.instance != null) {
    initialValues = {};
    ownProps.instance.fieldResults.forEach(function (result) {
      initialValues[result.fieldName] = result.value;
    });
  }

  return {
    translate: translate(state.Languages.translations),
    initialValues: initialValues
  };
}

export default connect(mapStateToProps, {
  updateFormInstance: updateFormInstance
})(FormInstance);